import { EventBus } from '../../helpers';
import type { TEventSource } from '../../helpers';

type InboundPromoCodesEvents = {
  inboundPromoCodesReceived: [codes: string[]];
};

class InboundPromoCodesEventBusClass extends EventBus<InboundPromoCodesEvents> {
  public override emit<K extends keyof InboundPromoCodesEvents>(
    event: K,
    ...args: [...InboundPromoCodesEvents[K], { source: TEventSource }]
  ): void {
    super.emit(event, ...args);
  }
}

export const inboundPromoCodesEventBus = new InboundPromoCodesEventBusClass();
